'use strict'

const getOffsetTop = (element) => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

const scrollToggleClass = {
  $scrollBasedEls: new Set(),
  $mobileHeader: null,
  mobileHeaderHeight: 0,
  resizeTimer: null,

  init(){
    this.$mobileHeader = document.querySelector('.mobile-header');
    /**
     * Example: Add class "in-viewport" when element is at least 100px visible
     * data-scroll-toggle-class="in-viewport" data-scroll-toggle-class-offset="-100"
     * Note: If element has CSS translations applied it will affect the intersecting
     */
    document.querySelectorAll('[data-scroll-toggle-class]').forEach($toggleClassEl => {
      const toggleClassName = $toggleClassEl.getAttribute('data-scroll-toggle-class');
      const offsetValue = $toggleClassEl.getAttribute('data-scroll-toggle-offset');
      const offset = (['top'].includes(offsetValue) ? offsetValue : parseFloat(offsetValue) || 0);
      const once = $toggleClassEl.hasAttribute('data-scroll-toggle-once');

      if(!toggleClassName){
        return;
      }

      if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        // No IntersectionObserver or user prefers reduced motion
        $toggleClassEl.classList.add(toggleClassName);
        return
      }

      if(typeof offset === 'number'){
        // Separate observer for each element because offset may be different
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.isIntersecting){
              entry.target.classList.add(toggleClassName);
              if(once){
                observer.unobserve(entry.target);
              }
            } else {
              if(once) return;
              entry.target.classList.remove(toggleClassName);
            }
          });
        }, {
          rootMargin: offset+'px'
        });

        observer.observe($toggleClassEl);
        return;
      }

      if(offset === 'top'){
        $toggleClassEl._toggleClassName = toggleClassName;
        this.$scrollBasedEls.add($toggleClassEl);
      }
    });

    if(this.$scrollBasedEls.size){
      this.getPositions();
      this.updateScrollBasedEls();

      document.addEventListener('scroll', () => {
        this.updateScrollBasedEls();
      }, {
        passive: true
      });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.getPositions();
          this.updateScrollBasedEls();
        }, 100);
      });
    }
  },

  getPositions(){
    this.mobileHeaderHeight = this.$mobileHeader.offsetHeight;

    for(const $el of this.$scrollBasedEls.values()){
      $el._pageTop = getOffsetTop($el);
    }
  },

  updateScrollBasedEls(evt){
    const documentScrollTop = document.documentElement.scrollTop;

    for(const $el of this.$scrollBasedEls.values()){
      const classAdded = $el.classList.toggle($el._toggleClassName, documentScrollTop + this.mobileHeaderHeight > $el._pageTop);
      $el.style.setProperty('--offset-top', (classAdded ? `${documentScrollTop + this.mobileHeaderHeight - $el._pageTop}px` : '0px'));
    }
  }
};

module.exports = scrollToggleClass;
